import { Selectbutton } from '@/shared/ui/Selectbutton'
import { useCommonCodes } from '@/shared/lib/codes'
import type { OrgNewDraft } from '@/public/features/org/types'
import { StepHeadLarge } from '@/public/features/org/ui/orgNew/parts'

export function StepType({ draft }: { draft: OrgNewDraft }) {
  const orgTypes = useCommonCodes('org_type')

  return (
    <section className="flex flex-col gap-8">
      <StepHeadLarge
        title="어떤 유형의 기업인가요?"
        desc="해당하는 기업 유형을 하나 선택해 주세요."
      />
      <div className="mx-auto flex w-full max-w-[343px] flex-wrap content-start gap-x-2 gap-y-2.5 [&>.ui-selectbutton]:w-[167.5px] [&>.ui-selectbutton]:min-w-[167px] [&>.ui-selectbutton]:shrink-0">
        {(orgTypes.data ?? []).map((t) => (
          <Selectbutton
            key={t.code}
            size="xl"
            label={t.label}
            isOn={draft.orgTypeCode === t.code}
            onSelect={() => draft.setOrgType(t.code)}
          />
        ))}
      </div>
    </section>
  )
}
